import Container from 'components/Container';

import styles from './Header.module.scss';

const Header = ({ children, style = {} }) => {
  return (
    <header className={styles.header} style={{...style}}>
      <Container>{children}</Container>
    </header>
  );
};

export default Header;
